import React from 'react';
import { useSelector } from 'react-redux';
import { SEARCH_PAGE_META } from 'lib/enums/search';
import { getPageTitle } from 'store/search/searchSelectors';
import Head from 'next/head';

const ListSearchMeta = () => {
  const pageTitle = useSelector(getPageTitle);

  return (
    <Head>
      <title>{pageTitle}</title>
      {SEARCH_PAGE_META.map(({ name, content }) => (
        <meta key={name} name={name} content={content} />
      ))}
    </Head>
  );
};

export default ListSearchMeta;
